import React, { useState } from 'react';
import {  Typography } from "@material-ui/core";
import {
    Loader,
    objestados,
    usuario_habilitado_sede,
    deshabilitar
} from './index.js';

import { useAutonomia } from '../../hooks/useAutonomia.js';
import { Spinner } from '@material-tailwind/react';
import Main from '../../../../componentes/Main.js';

import { Acta } from '../modulos/componentes/Acta';
import { FechaActa } from '../modulos/componentes/FechaActa';
import { Botones } from '../modulos/componentes/Botones';
import { PanelDatosGenerales } from '../modulos/componentes/PanelDatosGenerales';
import { ColumnasDinamicas } from '../modulos/componentes/ColumnasDinamicas.js';
import { FilasDinamicas } from '../modulos/componentes/FilasDinamicas.js';
import { TextoTruncado } from '../modulos/componentes/TextoTruncado.js';

export const TR_AutonomiaNew = ({ id, cabecera, setData, usuario, snackbar, puedeEditarse, cambiarStatus,finalizar }) => {

    const {
        error, loading, loading2, procesando, datosDelTramite, status_actual_tramite,
        acta_regional, setActa_regional, fechaAR, handleChangeFechaAR, setActa_cdn, fechaACDN,
        handleChangeFechaACDN, inicioActualizacionTramite, actualizarTramite, touched, refrescar,
        acta_cdn, refrescando, traerUrl, accederEntrevista, IniciarCerrarEntrevista,
        analitico, handleChangeAnaliticoCheck, nuevoAnalitico, setNuevoAnalitico,
        cambiarAnalitico, setCambiarAnalitico, nuevoExtra1, setNuevoExtra1,
        cambiarExtra1, setCambiarExtra1, linkEntrevista, copiarLink
    } = useAutonomia(cabecera, id, setData, usuario, snackbar);

    const [activeTab, setActiveTab] = useState('informacion_general');

    const sinCambiosPendientes = () => {
        return !(cambiarAnalitico && !nuevoAnalitico) && !(cambiarExtra1 && !nuevoExtra1);
    };

    if (error) return <div className="p-4 bg-red-50 text-red-700 rounded-lg"><p>{JSON.stringify(error)}</p></div>;
    
    if (loading || loading2 || procesando) {
        return (
            <Main center alinear>
                <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)] gap-3'>
                    <Spinner className="h-12 w-12 text-blue-500" />
                    <span className="font-semibold text-gray-600 text-sm">Cargando...</span>
                </div>
            </Main>
        );
    }
    
    if (!datosDelTramite) return <div className="p-8 text-center"><Spinner className="h-12 w-12 mx-auto text-blue-500" /><p className="text-gray-500 mt-2">Cargando solicitud...</p></div>;

    return (
        <div id="solicitud-proceso" className="w-full mx-auto space-y-4 antialiased text-gray-800">
            <Loader open={refrescando} />
            <div className="flex flex-col col-span-1 lg:col-span-7 bg-gray-50 border border-gray-200 rounded-md p-2  shadow-sm overflow-y-auto max-h-[500px]">
                <div className="flex flex-col gap-4">
                    <div className="flex flex-col gap-1">
                        <div className="flex flex-row flex-wrap gap-4 border border-gray-300 rounded-md bg-white p-3">
                                <Acta 
                                    estadoOcultoOConsolidado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                                    setActa={setActa_regional}
                                    acta={acta_regional}
                                    titulo="Número Acta Regional"
                                />
                                <FechaActa
                                    estadoOcultoOConsolidado={deshabilitar(status_actual_tramite, [objestados.procRegion.nombre], 'no_encontrado') || usuario.perfil !== 'region'}
                                        handleChangeFecha={handleChangeFechaAR}
                                        fecha={fechaAR}
                                        titulo="Fecha Acta Regional"
                                />                              
                                <Acta 
                                    estadoOcultoOConsolidado={deshabilitar(status_actual_tramite, [objestados.procSede.nombre], 'no_encontrado') || !usuario_habilitado_sede(usuario)}
                                    setActa={setActa_cdn}
                                    acta={acta_cdn}
                                    titulo="Número Acta CDN"
                                />       
                                <FechaActa
                                    estadoOcultoOConsolidado={deshabilitar(status_actual_tramite, [objestados.procSede.nombre], 'no_encontrado') || !usuario_habilitado_sede(usuario)}
                                        handleChangeFecha={handleChangeFechaACDN}
                                        fecha={fechaACDN}
                                        titulo="Fecha Acta CDN"
                                />                         
                        </div>
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full text-left items-start antialiased">
                    
                    <PanelDatosGenerales
                        datosDelTramite={datosDelTramite} 
                        atributos={[
                            {
                                valor:datosDelTramite?.iglesia?.nombre || 'No se encontró el nombre de la iglesia',
                                descripcion: 'Nombre del anexo'
                            },
                            {
                               // descripcion: 'Asistencia',
                               valor: () => (
                                    <ColumnasDinamicas 
                                        columnas={[
                                            { etiqueta: 'Número de miembros registrados', valor: datosDelTramite?.miembros_registrados || 'No informado' },
                                            { etiqueta: 'Asistencia promedio en el culto principal de la semana', valor: datosDelTramite?.promedio_semanal || 'No informado' }
                                        ]} 
                                    />
                                )
                            },  
                            {valor:(
                                <span title='Visualice el archivo' className='cursor-pointer text-blue-500 text-sm font-bold hover:underline' onClick={() => traerUrl(datosDelTramite?.actaURL)}>
                                📄 Acta de autonomía
                            </span>
                            ),descripcion:'Acta de autonomía'},
                            {
                                descripcion: 'Observaciones',
                                valor: () => <TextoTruncado texto={datosDelTramite.observaciones || ' - - '} limite={30} />
                            },                                                                               
                        ]}
                    />

                    <PanelDatosGenerales
                        datosDelTramite={datosDelTramite} 
                        atributos={[
                            {
                                descripcion: 'Encargado',
                                valor: (
                                    <div className="flex items-center justify-between gap-2 w-full mt-0.5">
                                        <span title={datosDelTramite.encargado.nombre} className="truncate max-w-56">{datosDelTramite.encargado.nombre}</span>
                                        
                                        <span className={`text-[10px] px-2 py-0.5 font-bold uppercase rounded-full tracking-wider border text-center ${
                                            datosDelTramite.encargado.esUad 
                                                ? 'bg-green-50 text-green-700 border-green-200' 
                                                : 'bg-amber-50 text-amber-700 border-amber-200'
                                        }`}>
                                            {datosDelTramite.encargado.esUad ? 'Es min. UAD' : 'Es Externo'}
                                        </span>

                                        <p title='Rango del encargado' className='text-ms mt-2'><span className='text-green-700'>{datosDelTramite?.encargado.rango || 'Rango desconocido'}</span> </p>

                                    </div>
                                )
                            },
                            { //descripcion:'Otros',
                           valor: () => (
                                    <FilasDinamicas 
                                        filas={[
                                            { 
                                                etiqueta: 'El encargado será sostenido por la iglesia', 
                                                valor: datosDelTramite?.encargado.sostenido_iglesia_si_no ? 'SI' : 'NO' 
                                            },
                                            { 
                                                etiqueta: 'Porcentaje de tiempo del sostenimiento recibido', 
                                                valor: `${datosDelTramite?.encargado.porcentaje_tiempo} %`,
                                                mostrar: datosDelTramite?.encargado.sostenido_iglesia_si_no 
                                            }
                                        ]} 
                                    />
                                )
                            }
                            
                        ]}
                    />

                    <PanelDatosGenerales
                        datosDelTramite={datosDelTramite} 
                        atributos={[
                            {
                                //descripcion: 'Detalles del Anexo',
                                valor: () => (
                                    <FilasDinamicas 
                                        filas={[
                                            { 
                                                etiqueta: 'El anexo tiene una comisión', 
                                                valor: datosDelTramite?.comision_si_no ? 'SI' : 'NO' 
                                            },
                                            {
                                                etiqueta: 'Comisión:',
                                                // Condición 1: Si hay comisión y tiene elementos, pasamos el JSX mapeado
                                                valor: datosDelTramite?.comision && datosDelTramite.comision.length > 0 ? (
                                                    <ul className="list-none text-left space-y-1">
                                                        {datosDelTramite.comision.map((item, i) => (
                                                            <li key={i} className="text-xs sm:text-sm">
                                                                <p className="font-bold text-slate-800">{item.nombre}</p>
                                                                <p className="text-[10px] text-red-600 font-semibold uppercase tracking-wider">{item.cargo}</p>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                ) : (
                                                    // Condición 2: Si la comisión viene vacía o no existe
                                                    'NO SE ENCONTRARON LOS DATOS DE LA COMISION'
                                                ),
                                                // Esta fila entera solo se procesa si el trámite dice tener comisión originalmente
                                                mostrar: datosDelTramite?.comision_si_no
                                            },
                                            { 
                                                etiqueta: 'Condición del edificio', 
                                                valor: datosDelTramite?.condicion_edificio 
                                            },
                                            { 
                                                etiqueta: 'Tiene libro de actas', 
                                                valor: datosDelTramite?.libro_actas_si_no ? 'SI' : 'NO' 
                                            },
                                            { 
                                                etiqueta: 'Tiene fichero de culto', 
                                                valor: datosDelTramite?.fichero_culto_si_no ? 'SI' : 'NO' 
                                            },
                                            { 
                                                etiqueta: 'Tiene certificado de afiliación', 
                                                valor: datosDelTramite?.certificado_afiliacion_si_no ? 'SI' : 'NO' 
                                            },
                                            { 
                                                etiqueta: 'Está enviando diezmos a la sede central', 
                                                valor: datosDelTramite?.envia_diezmos_si_no ? 'SI' : 'NO' 
                                            },
                                        ]} 
                                    />
                                )
                            }
                        ]}
                    />
{/*
                    <PanelDatosGenerales
                        datosDelTramite={datosDelTramite} 
                        atributos={[
                            {
                                valor: datosDelTramite.domicilio.direccion,
                                descripcion: 'Dirección'
                            },
                            {
                                descripcion: 'Localidad',
                                valor: (
                                    <div className="flex items-center justify-between gap-2 w-full mt-0.5">
                                        <span className="truncate">{datosDelTramite.domicilio.localidad}</span>
                                        
                                        {datosDelTramite.domicilio?.barrio && <span>
                                            ({datosDelTramite.domicilio?.barrio})
                                        </span>}
                                    </div>
                                )
                            },
                             {valor:(
                                  <div className="flex items-center justify-between gap-2 w-full mt-0.5">
                                        <span className="truncate">{datosDelTramite.domicilio.partido.nombre}</span>
                                        
                                        {datosDelTramite.domicilio?.barrio && <span>
                                            ({datosDelTramite.domicilio.provincia.nombre})
                                        </span>}
                                    </div>
                             ),descripcion:'Ubicación'}
                        ]}
                    /> */}
                </div>

            </div>
            <Botones
                sinCambiosPendientes={sinCambiosPendientes}
                touched={touched}
                inicioActualizacionTramite={inicioActualizacionTramite}
                actualizarTramite={actualizarTramite}
                cambiarStatus={cambiarStatus}
                finalizar={finalizar}
                puedeEditarse={puedeEditarse}
            />
        </div>
    );
};
